module.exports = __webpack_public_path__ + "static/media/handbags_featured.bc8bf48e.jpg";